import carEvents from './../config/carEvents';
import tippy from 'tippy.js';

export default function CarsCarouselController(
    $scope,
    $rootScope,
    carsFactory,
    searchData,
    carService,
    l10nService,
) {
    'ngInject';

            const vm = this;
            const BTN_TEXT_INACTIVE = l10nService.localize('SHOW COMPARISON TABLE');
            const BTN_TEXT_ACTIVE = l10nService.localize('HIDE COMPARISON TABLE');
            const NEGOTIATED_RATE_TITLE = l10nService.localize('Negotiated rate');

            Object.assign(vm, {
                $onInit,
                getCompanyLogo: carService.getCarSupplierLogo,
                clearCarsFilters,
                filterCarsBy,
                filtersApplied: carsFactory.filtersApplied,
                matrix: searchData.searchResults.matrix,
                composeCompanyLogoUrl: carService.getCarSupplierLogo,
                isComparisionTableVisible: false,
                btnText: BTN_TEXT_INACTIVE,
                negotiatedRateTitle: NEGOTIATED_RATE_TITLE,
                toggleComparisionTable,
            });

            function $onInit() {
                watch();
                initTooltip();
            }

            function initTooltip() {
                setTimeout(() => {
                    const negotiatedItems = document.querySelectorAll('.negotiated-price-info');
                    tippy(negotiatedItems, {placement: 'bottom', size: 'large'});
                }, 1000);
            }

            function watch() {
                $scope.$watch(() => carsFactory.getSearchResults(), newSearchResultsHandler);
            }

            function newSearchResultsHandler(newVal, oldVal) {
                vm.isComparisionButtonVisible = !!newVal.filteredTotal;

                if (newVal === oldVal) {
                    return;
                }
                vm.matrix = newVal.matrix;
            }

            function clearCarsFilters() {
                $rootScope.$broadcast(carEvents.CLEAR_CAR_FILTERS);
                vm.filtersApplied = carsFactory.filtersApplied = false;
            }

            function filterCarsBy(className, providerName) {
                const filters = carsFactory.getFilters();
                filters.CarClassFilter = [className];
                if (providerName) {
                    filters.CarProviderFilter = [providerName];
                }
                carsFactory.applyFilters(filters);
                initTooltip();
            }

             function toggleComparisionTable() {
                 vm.isComparisionTableVisible = !vm.isComparisionTableVisible;
                 if (vm.isComparisionTableVisible) {
                     vm.btnText = BTN_TEXT_ACTIVE;
                 } else {
                     vm.btnText = BTN_TEXT_INACTIVE;
                 }
             }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/carsCarouselCtrl.js